;(function(window, $) {
    window.ns = window.ns || {};

    window.ns['listing'] = {
        init: function() {
            $('.js-my-selection-trigger').mySelection();
        }
    };
})(window, jQuery);